import { Theme } from '@mui/material/styles'

export const getStyles = (theme: Theme) => ({
  root: { marginTop: theme.spacing(-0.2) },

  addButton: {
    height: '47px',
    minWidth: '47px',
    padding: theme.spacing(1),
    color: theme.palette.common.white,
    backgroundColor: '#0350a3',
    '&:hover': {
      backgroundColor: '#002d5c',
    },
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '160px',
  },

  searchContent: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '430px',
    width: '700px',
    padding: 0,
    [theme.breakpoints.up('xs')]: {
      width: '200px',
    },
    [theme.breakpoints.up('sm')]: {
      width: '300px',
    },
    [theme.breakpoints.up('md')]: {
      width: '662px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '662px',
    },
  },

  text: {
    fontSize: '12px',
    fontFamily: 'Source Sans Pro Semibold',
  },

  header: { padding: `${theme.spacing(1.1)} ${theme.spacing(1.8)}` },

  button: {
    width: '160px',
    height: '125px',
  },

  label: {
    display: 'flex',
    flexDirection: 'column',
  },

  avatarButton: { width: 'auto' },

  avatar: {
    width: '34px',
    height: '34px',
    border: 'solid 2px #1689ca',
    marginRight: '1vh',
  },

  listIcon: {
    minWidth: 'unset',
    marginLeft: 'auto',
  },

  searchIcon: {
    cursor: 'pointer',
    height: '40px',
  },
})
